<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17 2C17.5523 2 18 2.44772 18 3C18 3.51284 17.614 3.93551 17.1166 3.99327L17 4H9.04402L14.7894 11.3861C15.0421 11.7111 15.0674 12.1531 14.8652 12.5016L14.7894 12.6139L9.04402 20H17C17.5129 20 17.9355 20.386 17.9933 20.8834L18 21C18 21.5128 17.614 21.9355 17.1166 21.9933L17 22H7.00002C6.2057 22 5.74308 21.1279 6.14701 20.4774L6.21067 20.3861L12.733 12L6.21067 3.61394C5.723 2.98694 6.12734 2.08639 6.88886 2.00581L7.00002 2H17Z"
    fill="currentColor"
  />
</svg>
